<template>
    <div>
        <v-card-title>{{ eventName }}</v-card-title>
        <v-container>
            <v-card>
                <v-card-title>{{ participant.name }}</v-card-title>
            </v-card>
            <v-card>
                <v-card-title>抽選状況</v-card-title>
            </v-card>
        </v-container>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data() {
            return {
                userId: "",
                eventId: "",
                eventName: "",
                participant: {
                    name: "",
                }
            }
        },
        methods: {
        },
        async mounted() {
            const db = firebase.firestore()
            const userRef = db.collection("users").doc(this.$route.params.userId)
            const eventRef = userRef.collection("events").doc(this.$route.params.eventId)
            this.eventId = eventRef.id
            const eventData = await eventRef.get()
            this.eventName = eventData.data().name
            const participantRef = eventRef.collection("participants").doc(this.$route.params.participantId)
            const participantData = await participantRef.get()
            this.participant.name = participantData.data().name
        }
    }

</script>